export const PRINT_STATION_STORAGE_KEY = 'valenpos.printStationEnabled.v1';
export const PRINT_STATION_CHANGE_EVENT = 'valenpos:print-station-change';

export function isPrintStationEnabled() {
  if (typeof window === 'undefined') return false;
  return window.localStorage.getItem(PRINT_STATION_STORAGE_KEY) === 'true';
}

export function setPrintStationEnabled(enabled) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(PRINT_STATION_STORAGE_KEY, enabled ? 'true' : 'false');
  window.dispatchEvent(
    new CustomEvent(PRINT_STATION_CHANGE_EVENT, { detail: { enabled: Boolean(enabled) } })
  );
}
